/*
    Activity Groups that are informational are managed here on the front end.
    They include an infoDataType property from the backend, and this file maps them to informational components and returns them as activities.
    The infoDataType backend keys can be found in this spreadsheet:
    https://office365lds-my.sharepoint.com/:x:/r/personal/robinsonbc_churchofjesuschrist_org/_layouts/15/doc2.aspx?sourcedoc=%7B52CB80C7-87AA-4830-841D-D882FE3A4E34%7D&file=Book.xlsx&action=editnew&mobileredirect=true&wdNewAndOpenCt=1652393660480&ct=1652393660480&wdPreviousSession=0d610e2b-9889-499d-b34e-117f63d88224&wdOrigin=OFFICECOM-WEB.START.NEW&cid=0190def5-5a90-4fcc-bec0-e4da010c66c2
    under the info_data_type column.
*/
import { i18n } from '@fs/zion-locale'
import MinisteringAngels from './MinisteringAngels'
import TempleRecommendQuestions from './TempleRecommendQuestions'
import TempleRecommendQuestionsYouth from './TempleRecommendQuestionsYouth'
import PrepareChildForTemple from './PrepareForTemple'
import PrepareSpirituallyForTemple from './PrepareSpirituallyForTemple'
import PreparePracticallyForTemple from './PreparePracticallyForTemple'
import YourAncestorsNeedYou from './YourAncestorsNeedYou'
import TempleHistoryBlessings from './TempleHistoryBlessings'
import PreserveTempleMemory from './PreserveTempleMemory'
import PromisedBlessings from './PromisedBlessings'
import MyTemple from './MyTemple'
import { cdnRoot } from '../../services/services'

function asActivities(list) {
  return list.map((item) => ({
    type: 'informational',
    Content: item.activityType,
    data: item?.data,
  }))
}

export default {
  'ministering-angels': asActivities([{ activityType: MinisteringAngels }]),
  'temple-recommend-questions': asActivities([{ activityType: TempleRecommendQuestions }]),
  'temple-recommend-questions-youth': asActivities([{ activityType: TempleRecommendQuestionsYouth }]),
  'prepare-for-temple': asActivities([
    { activityType: PrepareChildForTemple },
    { activityType: PrepareSpirituallyForTemple },
    { activityType: PreparePracticallyForTemple },
    { activityType: YourAncestorsNeedYou },
    { activityType: TempleHistoryBlessings },
    { activityType: PreserveTempleMemory },
  ]),
  'temple-in-my-area': asActivities([{ activityType: MyTemple }]),
  'family-history-temple-promises': asActivities([
    {
      activityType: PromisedBlessings,
      data: {
        image: `${cdnRoot}/connect/informational/promised_blessings_temple.png`,
        heading: '',
        subHeading: '',
        quotes: [
          i18n.t(
            'informational.temple.promises.intro.paragraph1',
            'Today\'s youth are being confronted on every side with complex social issues, moral challenges, and significant temptations. As President Thomas S. Monson has taught, "decisions determine destiny." So how can the youth survive and thrive in these tumultuous times that were foreseen by prophets long ago?'
          ),
          i18n.t(
            'informational.temple.promises.intro.paragraph2',
            'One of the ways youth can fortify their spirits is to claim blessings promised by Church leaders if they participate in family history and temple work. What are these promised blessings?'
          ),
        ],
      },
    },
    {
      activityType: PromisedBlessings,
      data: {
        image: `${cdnRoot}/connect/informational/president_russell_nelson.png`,
        heading: i18n.t('informational.temple.promises-nelson', 'President Russell M. Nelson'),
        subHeading: i18n.t(
          'informational.temple.promises-nelson.title',
          'President of the Church of Jesus Christ of Latter-day Saints'
        ),
        quotes: [
          i18n.t(
            'informational.temple.promises.nelson.quote1',
            '“My dear extraordinary youth, you were sent to earth at this precise time, the most crucial time in the history of the world, to help gather Israel. There is nothing happening on this earth right now that is more important than that. There is nothing of greater consequence. Absolutely nothing. This gathering should mean everything to you. This is the mission for which you were sent to earth. So my question to you is “Are you willing to enlist in the youth battalion of the Lord to help gather Israel?”…So, now I am inviting every young woman and every young man between the ages of 12 and 18 in The Church of Jesus Christ of Latter-day Saints to enlist in the youth battalion of the Lord to help gather Israel…Anytime you do anything that helps anyone—on either side of the veil—take a step toward making covenants with God and receiving their essential baptismal and temple ordinances, you are helping to gather Israel. It is as simple as that. As you pray about sacrifice of time, you will be guided to know both what you can give up that week and what you can do instead to help gather Israel.”'
          ),
        ],
      },
    },
    {
      activityType: PromisedBlessings,
      data: {
        image: `${cdnRoot}/connect/informational/elder_renlund_portrait.png`,
        heading: i18n.t('informational.temple.promises.renlund', 'Elder Dale G. Renlund'),
        subHeading: i18n.t('informational.temple.promises.apostle.title', 'Quorum of the Twelve Apostles'),
        quotes: [
          i18n.t(
            'informational.temple.promises.renlund.quote1',
            '“I extend the promise of protection that’s been offered in the past.... I promise you protection for you and your family as you take this challenge to find as many names to take to the temple as ordinances you perform in the temple, and teach others to do the same.... If you accept this challenge, blessings will begin to flow to you and your family.... You’ll find not only protection from the temptations and ills of this world, but you’ll also find personal power, power to change, power to repent, power to learn, power to be sanctified, and power to turn the hearts of your family together and heal that which needs healing.”'
          ),
          i18n.t(
            'informational.temple.promises.renlund.quote2',
            '“When we gather our family histories and go to the temple on behalf of our ancestors, God fulfills promised blessings simultaneously on both sides of the veil.” '
          ),
        ],
      },
    },
    {
      activityType: PromisedBlessings,
      data: {
        image: `${cdnRoot}/connect/informational/elder_quentin_l_cook.png`,
        heading: i18n.t('informational.temple.promises.cook', 'Elder Quentin L. Cook'),
        subHeading: i18n.t('informational.temple.promises.apostle.title', 'Quorum of the Twelve Apostles'),
        quotes: [
          i18n.t(
            'informational.temple.promises.cook.quote',
            '“If the youth in each ward will not only go to the temple and do baptisms for their dead but also work with their families and other ward members to provide the family names for the ordinance work they perform, both they and the Church will be greatly blessed.”'
          ),
        ],
      },
    },
    {
      activityType: PromisedBlessings,
      data: {
        image: `${cdnRoot}/connect/informational/elder_david_a_bednar.png`,
        heading: i18n.t('informational.temple.promises.bednar', 'Elder David A. Bednar'),
        subHeading: i18n.t('informational.temple.promises.apostle.title', 'Quorum of the Twelve Apostles'),
        quotes: [
          i18n.t(
            'informational.temple.promises.bednar.quote',
            '“I encourage you to study, to search out your ancestors, and to prepare yourselves to perform proxy baptisms in the house of the Lord for your kindred dead.... “As you respond in faith to this invitation, your hearts shall turn to the fathers.... And I promise you will be protected against the intensifying influence of the adversary. As you participate in and love this holy work, you will be safeguarded in your youth and throughout your lives.”'
          ),
        ],
      },
    },
    {
      activityType: PromisedBlessings,
      data: {
        image: `${cdnRoot}/connect/informational/elder_alan_f_packer.png`,
        heading: i18n.t('informational.temple.promises.packer', 'Elder Allan F. Packer'),
        subHeading: i18n.t('informational.temple.promises.seventy.title', 'General Authority Seventy'),
        quotes: [
          i18n.t(
            'informational.temple.promises.packer.quote',
            '“Like partaking of the sacrament, attending meetings, reading the scriptures, and saying personal prayers, doing family history and temple work should be a regular part of our personal worship. The response of our youth and others to prophetic invitations has been inspiring and proves this work can and should be done by all members at any age.”'
          ),
        ],
      },
    },
    {
      activityType: PromisedBlessings,
      data: {
        image: `${cdnRoot}/connect/informational/sister_elaine_dalton.png`,
        heading: i18n.t('informational.temple.promises.dalton', 'Sister Elaine Dalton'),
        subHeading: i18n.t('informational.temple.promises.dalton.title', 'Former Young Women General President'),
        quotes: [
          i18n.t(
            'informational.temple.promises.dalton.quote',
            '“This is our day, and temple work is the work that we have been prepared to do. It is a work for every generation.... “[The youth] have been reserved for these latter days, and they have a great work to do. And not only do they have a great work to do there, but the temples will also be a refuge for them that will protect them from worldly pressures and influences.”'
          ),
        ],
      },
    },
    {
      activityType: PromisedBlessings,
      data: {
        image: `${cdnRoot}/connect/informational/president_russell_nelson.png`,
        heading: 'President Russell M. Nelson',
        subHeading: 'President of the Church of Jesus Christ of Latter-day Saints',
        quotes: [
          i18n.t(
            'informational.temple.promises.nelson.quote2',
            'Consider the spiritual connections that are formed when a young woman helps her grandmother enter family information into a computer.... When our hearts turn to our ancestors, something changes inside us. We feel part of something greater than ourselves.”'
          ),
        ],
      },
    },
  ]),
}
